import { Injectable, NgZone } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '@shared/shared.service';

@Injectable()
export class PermissionGuard  {
  constructor(
    private sharedService: SharedService,
    private router: Router,
    private ngzone: NgZone
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let permissionModules = [];
    permissionModules = JSON.parse(localStorage.getItem('permissionModules') || '[]');
    const modulename = route.data.moduleName;
    localStorage.setItem('currentModule', modulename);
    return this.checkPermission(modulename, permissionModules).then(res => {
      if (res) {
        return true;
      } else {
        this.sharedService.setDefaultUrl(permissionModules);
        return false;
      }
    });
  }
  // checkPermission(modulename, permissionModules): Promise<boolean> {
  //   if (permissionModules) {
  //     let checkmodule = permissionModules.includes(modulename);
  //     if (!checkmodule && modulename === 'OTA') {
  //       checkmodule = permissionModules.includes('OTA-PARTNER');
  //     }
  //     return Promise.resolve(checkmodule);
  //   } else {
  //     this.router.navigate(['login']);
  //   }
  // }
  checkPermission(modulename: string, permissionModules: any): Promise<boolean> {
    if (!permissionModules) {
      this.router.navigate(['login']);
      return Promise.resolve(false);
    }
    // OTA and OTA-PARTNER accounts never get Admin, even with ADMIN permission
    if (modulename === 'ADMIN' && this.sharedService.hasOtaAccess()) {
      return Promise.resolve(false);
    }
    // Data Hub is exclusive to OTA-PARTNER
    if (modulename === 'DATAHUB') {
      return Promise.resolve(this.sharedService.hasDataHubAccess());
    }
    const allowed =
      permissionModules.includes(modulename) ||
      (modulename === 'OTA' && this.sharedService.hasOtaAccess());
    if (allowed && modulename === 'OTA' && this.sharedService.isOtaPartner()) {
      const partnerModule = permissionModules.find((m: any) =>
        this.sharedService.isOtaPartnerModule(m)
      );
      localStorage.setItem('currentModule', partnerModule || 'OTA-PARTNER');
    }
    return Promise.resolve(allowed);
  }
}
